module.exports = __webpack_public_path__ + "static/img/annie-spratt-DFN15KyskrQ-unsplash.989bf54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/annie-spratt-DFN15KyskrQ-unsplash.jpg
// module id = maVe
// module chunks = 1